import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { Observable, throwError } from 'rxjs';

import { HttpResponse, HttpHeaders } from '@angular/common/http';

@Injectable()
export class LicensesCardService {
  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService) { }


  handleError = (error) => {
    return throwError(error);
  }

  setUpdateProduct(url, data) {
    let headers = new HttpHeaders();
    headers = headers.append('PermType', 'inventory.productDescription');
    const descObj = {};
    descObj['name'] = data.productDesc;
    const newUrl = url + data.clientId;
    return this.httpClientService.authorizedPatch(newUrl, descObj, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res.body);
      }
      ),catchError( this.handleError ));
  }
}
